import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { EagerSelectEffects } from '../../select/eager-select/eager-select-effects';
import { extensionHuntGroupsOptionSelectors } from './extension-option-reducers/extension-huntgroup-option.reducer';
import { extensionQueueOptionSelectors } from './extension-option-reducers/extension-queue-option.reducer';
import {
   extensionLoadAutoAttendantsActions,
   extensionLoadHuntGroupsActions,
   extensionLoadQueuesActions,
   extensionOptionActions,
} from './extension-option.actions';
import { extensionOptionSelectors } from './extension-option.reducer';

@Injectable({ providedIn: 'root' })
export class ExtensionOptionEffects {
   defaultFields: string[] = ['name', 'extensionId', 'number', 'type', 'shortName'];

   defaultOrderingOptions: string[] = ['number:asc'];

   staticFilters: string[] = [];

   load = this.eagerSelectEffects.createEagerSelectorLoadEffect(
      extensionOptionSelectors.selectState,
      'extensions?SerializeEnumsAsStrings=true',
      this.defaultFields,
      this.defaultOrderingOptions,
      extensionOptionActions,
      this.staticFilters
   );

   loadAutoAttendants = this.eagerSelectEffects.createEagerSelectorLoadEffect(
      extensionOptionSelectors.selectState,
      'extensions?SerializeEnumsAsStrings=true',
      this.defaultFields,
      this.defaultOrderingOptions,
      extensionLoadAutoAttendantsActions,
      this.staticFilters
   );

   loadQueues = this.eagerSelectEffects.createEagerSelectorLoadEffect(
      extensionQueueOptionSelectors.selectState,
      'extensions?SerializeEnumsAsStrings=true',
      this.defaultFields,
      this.defaultOrderingOptions,
      extensionLoadQueuesActions,
      this.staticFilters
   );

   loadHuntGroups = this.eagerSelectEffects.createEagerSelectorLoadEffect(
      extensionHuntGroupsOptionSelectors.selectState,
      'extensions?SerializeEnumsAsStrings=true',
      this.defaultFields,
      this.defaultOrderingOptions,
      extensionLoadHuntGroupsActions,
      this.staticFilters
   );

   constructor(private eagerSelectEffects: EagerSelectEffects<AppState>, private store: Store) {}
}
